<template>
  <div class="calico-usage-dialog-page">
    <div class="qa-actions">
      <button
        class="button-primary"
        @click="openWithData"
      >
        Open “Usage” (with data)
      </button>

      <button
        class="button-secondary"
        @click="openNoData"
      >
        Open “Usage” (no data)
      </button>
    </div>

    <UsageDialog
      v-if="open && mode === 'with'"
      :usage="mockWithData"
      :loading="false"
      :error-message="''"
      @close="open = false"
    />

    <UsageDialog
      v-if="open && mode === 'empty'"
      :usage="mockEmpty"
      :loading="false"
      :error-message="''"
      @close="open = false"
    />
  </div>
</template>

<script>
import UsageDialog from "@/components/pattern/usageDialog/index.vue";

export default {
  name: "CalicoUsageDialogPage",

  components: {
    UsageDialog
  },

  data() {
    return {
      open: false,
      mode: "with",

      mockWithData: {
        cycle: {
          start: "2025-09-06T00:00:00.000Z",
          endExclusive: "2025-10-06T00:00:00.000Z"
        },
        me: {
          distinctBusinesses: 15
        },
        organization: {
          distinctBusinesses: 85,
          allowance: 100,
          remaining: 85
        },
        betascores: {
          active: [
            {
              id: 24,
              name: "McDonald's"
            },
            {
              id: 25,
              name: "HOME DEPOT INC"
            },
            {
              id: 26,
              name: "Crown Battery Manufacturing Co"
            }
          ]
        }
      },

      mockEmpty: {
        cycle: null,
        me: {
          distinctBusinesses: 0
        },
        organization: null,
        betascores: {
          active: []
        }
      }
    };
  },

  methods: {
    openWithData() {
      this.mode = "with";
      this.open = true;
    },

    openNoData() {
      this.mode = "empty";
      this.open = true;
    }
  }
};
</script>

<style lang="scss">
.calico-usage-dialog-page {
  width: 100%;
  height: 100vh;
  background: rgb(103, 100, 100);
  @include inset-space($space-medium);
  display: flex;
  align-items: center;
  justify-content: center;

  .qa-actions {
    @include stack-space($space-medium);
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>